import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'help_center-search_article-keyboard_input';

/**
 * Search articles by typing through the keyboard
 */
export function trackHelpCenterSearchArticleKeyboardInput(
  search_bar_location: string,
  retailerToken: string,
  brandToken: string,
  search_value2: string,
  position3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      search_bar_location,
      retailerToken,
      brandToken,
      search_value2,
      position3,
    },
  });
}

/**
 * Trace for event: help_center-search_article-keyboard_input
 */
export function trackHelpCenterSearchArticleKeyboardInputTraceApiRequestEnd(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'help_center-search_article-keyboard_input-trace-api_request_end',
    realTimeTracking: false,
    sourceEventKey: 'help_center-search_article-keyboard_input',
    sourceEventMarker,
  });
}

/**
 * Trace for event: help_center-search_article-keyboard_input
 */
export function trackHelpCenterSearchArticleKeyboardInputTraceApiRequestStart(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey:
      'help_center-search_article-keyboard_input-trace-api_request_start',
    realTimeTracking: false,
    sourceEventKey: 'help_center-search_article-keyboard_input',
    sourceEventMarker,
  });
}

/**
 * Trace for event: help_center-search_article-keyboard_input
 */
export function trackHelpCenterSearchArticleKeyboardInputTraceRendered(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'help_center-search_article-keyboard_input-trace-rendered',
    realTimeTracking: false,
    sourceEventKey: 'help_center-search_article-keyboard_input',
    sourceEventMarker,
  });
}
